export const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const base64ToByteArray = (base64) => {
  let bytes = [];
  try {
    const binaryString = atob(base64.split(',')[1]); // Decode base64 string
    const len = binaryString.length;
    bytes = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
  } catch (e) {
    bytes = [];
  }
  return bytes;
};

// Convert base64 to Blob
export const base64ToBlob = (base64, contentType = 'image/png') => {
  const byteArray = base64ToByteArray(base64);
  if (0 < byteArray.length) {
    return new Blob([byteArray], { type: contentType });
  }
  return null;
};

// Convert base64 string to a Blob
export const base64ToBlob1 = (base64, contentType = 'image/png') => {
  const byteCharacters = atob(base64.split(',')[1]); // Remove base64 prefix
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
};
